export const transitions = {
  easeQuick: '0.2s ease',
  easeMedium: '0.3s ease',
};
